export default "__VITE_ASSET__k9OTVI4G__"